module.exports = __webpack_public_path__ + "static/media/Pomp.896ae83e.jpg";